import { useTranslation } from "react-i18next";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

import { Props, ViaPlatformOptionValue, ViaPlatformQuickFilter } from "./interfaces";

export const ViaPlatformQuickfilter = <Q extends ViaPlatformQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.via_platform";

  const options: QuickFilterOption<ViaPlatformOptionValue>[] = [
    {
      name: "All ",
      value: {
        viaPlatforms: [
          {
            viaAndroid: true,
            viaIPhone: true,
            viaWeb: true,
          },
        ],
      },
    },
    {
      name: "via IPhone",
      value: {
        viaPlatforms: [
          {
            viaAndroid: false,
            viaIPhone: true,
            viaWeb: false,
          },
        ],
      },
    },
    {
      name: "Via Android",
      value: {
        viaPlatforms: [
          {
            viaAndroid: true,
            viaIPhone: false,
            viaWeb: false,
          },
        ],
      },
    },
    {
      name: "Via Web",
      value: {
        viaPlatforms: [
          {
            viaAndroid: false,
            viaIPhone: false,
            viaWeb: true,
          },
        ],
      },
    },
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="viaPlatform"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
      isMultiSelect
      multiSelectField="viaPlatforms"
      customWidth={"170px"}
    />
  );
};
